module.exports = __webpack_public_path__ + "static/img/hb_56-min.fa679d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_56-min.png
// module id = Z/aS
// module chunks = 1